import useAddFallowing from 'hooks/addEdit/useAddEditFallowing';
import useParseURL from 'hooks/useParseURL';

import {StyledDatesContainer, StyledSpacerRow} from 'styles/InputMenu';

import InputActionButtons from './InputActionButtons';

import {useGetSites} from 'hooks/swr';
import {isValidDate} from 'helpers/UnitsFormatHandler';
import {GenericSelect, GenericSelectItem} from 'components/Generic/Selectors';
import {useTranslation} from 'react-i18next';
import {InputMenuDatePicker} from 'components/Generic/DatePickersV2/InputMenuDatePicker';

const AddSiteFallowing = () => {
  const {t} = useTranslation('common');

  const {siteFallowing, setSiteFallowing, setCreateUpdateSiteFallowing, inputMenuContext} = useAddFallowing();
  const {planId} = useParseURL();

  const {data: sites} = useGetSites({resourceId: planId});

  const closedMenu = inputMenuContext && Object.keys(inputMenuContext.state).length === 0;
  const isValid =
    siteFallowing?.startDate &&
    siteFallowing?.endDate &&
    isValidDate(siteFallowing.startDate) &&
    isValidDate(siteFallowing.endDate);

  return (
    <form noValidate autoComplete="off" style={{width: '100%'}}>
      {import.meta.env.NODE_ENV === 'test' && <h1>{closedMenu ? 'TEST CLOSE MENU' : 'TEST OPEN MENU'}</h1>}

      {/* Site Picker */}
      <GenericSelect
        inputProps={{'data-testid': 'site'}}
        value={siteFallowing?.siteId ?? ''}
        onChange={(event) => {
          const siteId = event.target.value as string;
          siteFallowing && setSiteFallowing({...siteFallowing, siteId});
        }}
        label={t('site')}
      >
        {sites?.map((site) => (
          <GenericSelectItem key={site.id} value={site.id}>
            {site.name}
          </GenericSelectItem>
        ))}
      </GenericSelect>
      <StyledSpacerRow />
      <StyledDatesContainer border={1} borderRadius="4px" p={2}>
        <InputMenuDatePicker
          value={siteFallowing?.startDate}
          onChange={(date) => siteFallowing && setSiteFallowing({...siteFallowing, startDate: date})}
          slotProps={{
            textField: {
              inputProps: {
                'data-testid': 'start-date',
              },
            },
          }}
          label={t('startDatePlaceholder')}
        />
        <StyledSpacerRow />
        <InputMenuDatePicker
          value={siteFallowing?.endDate}
          onChange={(date) => siteFallowing && setSiteFallowing({...siteFallowing, endDate: date})}
          slotProps={{
            textField: {
              inputProps: {
                'data-testid': 'end-date',
              },
            },
          }}
          label={t('endDatePlaceholder')}
        />
      </StyledDatesContainer>

      <StyledSpacerRow />
      <StyledSpacerRow />

      <InputActionButtons disabled={!isValid} setCreateUpdateInput={setCreateUpdateSiteFallowing} />
    </form>
  );
};

export default AddSiteFallowing;
